import type { Extra } from "@scrile/contracts";
import { Icon } from "../components/Icon";
import { t } from "../i18n";
import { formatClock, formatMinutes, formatShortDate } from "../lib/format";

/**
 * Рубрики и голосовые с именем — то, что приходит каждую неделю помимо серий.
 * Порядок — свежие сверху: это лента, а не сезон. Запертый выпуск (Extra.locked) виден —
 * так понятно, за что подписка, — и ведёт на пейвол; адреса дорожки у него нет.
 */
export function ExtrasList({
  extras,
  currentId,
  playing,
  onPlay,
  onLocked,
}: {
  extras: readonly Extra[];
  currentId: string | null;
  playing: boolean;
  onPlay: (extra: Extra) => void;
  onLocked: (extra: Extra) => void;
}) {
  const sorted = [...extras].sort((a, b) => b.releasedAt.localeCompare(a.releasedAt));
  return (
    <ul className="extras">
      {sorted.map((extra) => {
        const current = extra.id === currentId;
        const length = extra.lengthSec < 90 ? formatClock(extra.lengthSec) : formatMinutes(extra.lengthSec);
        return (
          <li key={extra.id}>
            <button
              type="button"
              className={`extra${current ? " extra--current" : ""}${extra.locked ? " extra--locked" : ""}`}
              onClick={() => (extra.locked ? onLocked(extra) : onPlay(extra))}
            >
              <span className="extra__icon" aria-hidden="true">
                <Icon name={extra.kind === "rubric" ? "rubric" : "voice"} size={20} />
              </span>
              <span className="extra__body">
                <span className="extra__title">{extra.title}</span>
                <span className="extra__meta">
                  {t(extra.kind === "rubric" ? "player.extra.rubric" : "player.extra.voice_note")} · {length} ·{" "}
                  {formatShortDate(extra.releasedAt)}
                </span>
              </span>
              {extra.locked ? (
                <span className="extra__action extra__action--locked" aria-label={t("episode.locked")}>
                  <Icon name="lock" size={18} />
                </span>
              ) : (
                <span className="extra__action" aria-label={current && playing ? t("player.pause") : t("player.play")}>
                  <Icon name={current && playing ? "pause" : "play"} size={18} />
                </span>
              )}
            </button>
          </li>
        );
      })}
    </ul>
  );
}
